
export const SmallGroupLessonType = {
  COMPREHENSION: 'Comprehension',
  MORPHOLOGY_VOCABULARY: 'Morphology/Vocabulary',
  DECODING_WORD_RECOGNITION: 'Decoding',
  SPELLING: 'Spelling',
  SPELLING_DEVELOPMENT: 'Spelling Development',
  SYLLABLE: 'Syllable Focus',
  PHRASING: 'Phrasing',
}

export interface SmallGroupLesson {
  type: keyof typeof SmallGroupLessonType;
  tasks: string[];
}

export const SmallGroupLessons = [
  {
    type: SmallGroupLessonType.COMPREHENSION,
    tasks: [
      'PASS',
      'PAQ',
      'PIC',
      'PAP',
      'PAW',
      'PAS'
    ],
  },
  {
    type: SmallGroupLessonType.MORPHOLOGY_VOCABULARY,
    tasks: [
      'CTM',
      'PIC',
    ],
  },
  {
    type: SmallGroupLessonType.DECODING_WORD_RECOGNITION,
    tasks: [
      'FB',
      'FTW',
      'FWF',
      'CHW',
      'RHY',
      'MPIC',
      'PCIM',
      'FSM',
    ],
  },
  {
    type: SmallGroupLessonType.SPELLING,
    tasks: [
      'SPELL',
    ],
  },
  {
    type: SmallGroupLessonType.SPELLING_DEVELOPMENT,
    tasks: [
      'STW',
    ],
  },
  {
    type: SmallGroupLessonType.SYLLABLE,
    tasks: [
      'MTW',
      'FSU',
      'FSB',
    ],
  },
  {
    type: SmallGroupLessonType.PHRASING,
    tasks: [
      'FTP',
      'MTP',
    ],
  },
]
